<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-card :title="$t('warehouse.inventory-invoice')">
      <div>
        <!-- <b-row>
          <b-col cols="12" md="12">
            <h2>Filter Invoices</h2>
            <br />
          </b-col>

          <b-col cols="11">
            <b-form-group label="Item">
              <AutoComplete
                class="mt-1"
                placeholder="Select Employee"
                v-model="employeeId"
                param-query="search"
                :serializer="(val) => val.id"
                endpoint="employees"
                text-title="name"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="1"
            class="d-flex align-items-center justify-content-end mt-1"
          >
            <b-button variant="primary" @click="getInventoryInvoices()">
              Search
            </b-button>
          </b-col>
        </b-row> -->

        <!-- Search Button -->

        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t('common.table') }} {{ $t('warehouse.invoices') }}</h2>
          <b-button
            variant="primary"
            @click="
              $router.push({
                name: `${
                  $route.name.includes('pharmacy')
                    ? 'pharmacy-add-stockout'
                    : 'add-stockout'
                }`,
              })
            "
          >
            {{ $t('common.create') }} {{ $t('warehouse.invoice') }}
          </b-button>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap d-flex">
              <!-- @click="printId(data.item.id)" -->
              <b-button
                variant="outline-warning"
                pill
                size="sm"
                class="mx-2"
                @click="
                  $router.push({
                    name: `${
                      $route.name.includes('pharmacy')
                        ? 'pharmacy-stockout'
                        : 'stockout'
                    }`,
                    params: { id: data.item.id },
                  })
                "
              >
                {{ $t('warehouse.show-invoice-items') }}
              </b-button>
              <ActionsButtons
                :noEdit="true"
                deletePerm="delete-stockout"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t('common.showing') }} 1 {{ $t('common.to') }} 10
                {{ $t('warehouse.one-item') }}</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getInventoryInvoices()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue';
const AutoComplete = () => import('@/components/common/AutoComplete.vue');
import Datepicker from 'vuejs-datepicker';
import ActionsButtons from '@/components/common/ActionsButtons.vue';
import DeleteModal from '@/components/modals/DeleteModal.vue';
export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BLink,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    StatisticCardHorizontal,
    AutoComplete,
    Datepicker,
    ActionsButtons,
    DeleteModal,
  },
  data() {
    return {
      take: 10,
      loading: true,
      itemId: '',
      categoryId: null,
      stocks: [
        {
          categoryId: '',
          quantity: '',
          batch_no: '',
          unit_price: 0,
          expiry_date: '',
          warehouse_id: '',
          item_id: this.itemId,
        },
      ],
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        quantity: '',
        batch_no: '',
        unit_price: 0,
        expiry_date: '',
        warehouse_id: '',
        item_id: this.itemId,
        _method: 'PUT',
      },
      createMode: false,
      errorForm: {
        name: '',
        category_id: '',
      },
      params: {
        form: {},
        path: '',
      },
      tableColumns: [
        {
          key: 'employee.full_name.',
          label: this.$t('common.name'),
          sortable: true,
        },
        { key: 'date', label: this.$t('common.date'), sortable: true },
        {
          key: 'description',
          label: this.$t('common.description'),
          sortable: true,
        },

        { key: 'Actions', label: this.$t('common.actions') },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
    };
  },
  mounted() {
    this.getInventoryInvoices();
  },
  methods: {
    show(item, mode) {
      if (mode === 'create') {
        this.createMode = true;
        this.stocks = [
          {
            categoryId: '',
            quantity: '',
            batch_no: '',
            unit_price: 0,
            expiry_date: '',
            warehouse_id: '',
            item_id: this.itemId,
            _method: 'POST',
          },
        ];
      } else {
        this.createMode = false;
        this.EditForm.category_id = item.category_id;
        this.EditForm.id = item.id;
        this.EditForm.quantity = item.quantity;
        this.EditForm.batch_no = item.batch_no;
        this.EditForm.expiry_date = item.expiry_date;
        this.EditForm.warehouse_id = item.warehouse_id;
        this.EditForm.unit_price = item.unit_price;
        this.EditForm.item_id = item.item_id;
        this.EditForm._method = 'PUT';
      }
      this.$bvModal.show('modal-edit');
    },

    async getInventoryInvoices() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/inventoryInvoice?filter[type]=${
        this.$route.name.includes('pharmacy') ? 'pharmacy' : 'hospital'
      }&page=${this.page}&take=${this.take}&sort=-id&include=employee`;

      if (this.employeeId) {
        url += `&filter[employee_id]=${this.employeeId}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show('modal-delete');
    },
    deleteItem() {
      this.$store
        .dispatch('delete', `/inventoryInvoice/${this.deleteForm.id}`)
        .then((response) => {
          this.getInventoryInvoices();

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: 'deleted ' + this.deleteForm.first_name + ' successfully',
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'Error deleting ' + this.deleteForm.first_name,
            },
          });
        });
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
